export default __webpack_public_path__ + "static/media/redAlert.1452c8ef.svg";